import { render, staticRenderFns } from "./PushLabelModal.vue?vue&type=template&id=ff406cea&"
import script from "./PushLabelModal.vue?vue&type=script&lang=js&"
export * from "./PushLabelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports